import { useQuery } from '@tanstack/react-query';
import { fetcher } from '../libs';

type Survey = {
  id: string;
  survey: number;
  response: number[];
};

export default function useSurveysQuery() {
  return useQuery(['onboard', 'survey'], () => {
    return fetcher<Survey[]>('/accounts/survey/all');
  });
}
